import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f14884f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "priority_desc" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "w-100 pb-4 priority_desc" }
const _hoisted_4 = { class: "my-2 text-primary w-100 d-flex flex-wrap align-items-center justify-content-end" }
const _hoisted_5 = { class: "mb-0 d-none" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Needs", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "mb-4 text-primary" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "details" }
const _hoisted_12 = { class: "text-capitalize" }
const _hoisted_13 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Program-Area : ", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "SubProgram-Area : ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_through" }, null, -1))
const _hoisted_18 = { class: "mb-lg-5 mb-md-3 write_ups" }
const _hoisted_19 = { class: "mb-lg-5 mb-md-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Description of Health Need/Challenge", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Description of Required Solution", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Target End User:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-3" }, "Benefits to End User", -1))
const _hoisted_24 = {
  key: 0,
  class: "attached_file"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("h6", null, "Attached files")
], -1))
const _hoisted_26 = ["href"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Please note that when submitting your innovation proposal your preferred stage of proposal is Stage 4: Transition to scale process.", -1))
const _hoisted_30 = { class: "" }
const _hoisted_31 = { class: "my-5 d-flex flex-wrap justify-content-lg-end justify-content-center" }
const _hoisted_32 = { class: "container-fluid mb-lg-5 mb-md-3 px-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center text-primary my-3" }, "Other Related Needs", -1))
const _hoisted_34 = {
  key: 0,
  class: "row"
}
const _hoisted_35 = {
  key: 1,
  class: "container-fluid mx-auto row justify-content-between"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_LoginModal = _resolveComponent("LoginModal")!
  const _component_InterestModal = _resolveComponent("InterestModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h6", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/submit-proposal/call-for-proposal" }, {
              default: _withCtx(() => [
                _createTextVNode("Submit Proposal")
              ]),
              _: 1
            }),
            _createTextVNode(" / "),
            _hoisted_6
          ]),
          _createVNode(_component_Button, {
            label: "Back",
            icon: "pi pi-chevron-left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            class: "p-button-text p-button-raised",
            "aria-label": "Back"
          })
        ])
      ]),
      (!_ctx.healthNeed?.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "12vh",
              class: "mb-3"
            }),
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "40vh",
              class: "mb-3"
            }),
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "8vh",
              class: "mb-3"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.healthNeed.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("section", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.healthNeed.title), 1),
                  (_ctx.healthNeed?.program_areas?.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("i", null, [
                          _createElementVNode("u", null, _toDisplayString(_ctx.healthNeed?.program_areas[0]?.name), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.healthNeed?.specific_program_areas.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("small", null, [
                          _hoisted_16,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.healthNeed.specific_program_areas, (item, i) => {
                            return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(item.name) + ",  ", 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_17
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("p", null, _toDisplayString(_ctx.healthNeed.description), 1),
                _hoisted_21,
                _createElementVNode("p", null, _toDisplayString(_ctx.healthNeed.requirements), 1),
                _hoisted_22,
                _createTextVNode(" " + _toDisplayString(_ctx.healthNeed.target_users) + " ", 1),
                _hoisted_23,
                _createElementVNode("p", null, _toDisplayString(_ctx.healthNeed.benefits), 1),
                (_ctx.healthNeed?.document_upload?.length > 1)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                      _hoisted_25,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.healthNeed.document_upload, (item, i) => {
                        return (_openBlock(), _createElementBlock("li", { key: i }, [
                          _createElementVNode("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: item
                          }, [
                            _createElementVNode("img", {
                              src: 
                      require(`@/assets/placeholder/${_ctx.getFileExt(item)}.svg`)
                    ,
                              alt: "placeholder_img ",
                              width: "40"
                            }, null, 8, _hoisted_27),
                            _createElementVNode("span", _hoisted_28, " " + _toDisplayString(_ctx.getFileName(item)), 1)
                          ], 8, _hoisted_26)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", null, [
                _hoisted_29,
                _createVNode(_component_router_link, { to: "/resource-library/stages" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Click here to view the Stages of Innovations")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, [
                  _createTextVNode(" Innovation proposal must have passed the regulatory and ethical requirements\" For more information, visit the resource library "),
                  _createVNode(_component_router_link, { to: "/resource-library/documents" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Here")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_BaseButton, {
                  disabled: _ctx.accountType !== 'innovators' && _ctx.authStatus === true,
                  onButtonClick: _ctx.submitInnovation,
                  customStyle: _ctx.btnStyleAlt
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Submit an innovation proposal")
                  ]),
                  _: 1
                }, 8, ["disabled", "onButtonClick", "customStyle"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_32, [
      _hoisted_33,
      (_ctx.relatedDatas?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedDatas, (item, i) => {
              return (_openBlock(), _createBlock(_component_Card, {
                key: i,
                body: item,
                card: _ctx.cardDescriptionStyle,
                route: `/submit-proposal/call-for-proposal/${item.id}`
              }, null, 8, ["body", "card", "route"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_35, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
              return _createVNode(_component_Skeleton, {
                key: i,
                height: "15vh",
                width: "24%",
                class: "mb-3 col-lg-3 col-md-6 col-12"
              })
            }), 64))
          ]))
    ]),
    (_ctx.authStatus === false && _ctx.showLogin === true)
      ? (_openBlock(), _createBlock(_component_LoginModal, {
          key: 0,
          onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLogin = false)),
          id: _ctx.healthNeed.id
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    (_ctx.interestStatus)
      ? (_openBlock(), _createBlock(_component_InterestModal, {
          key: 1,
          id: _ctx.healthNeed.id,
          onSubmitted: _cache[2] || (_cache[2] = ($event: any) => (_ctx.interestStatus = false))
        }, null, 8, ["id"]))
      : _createCommentVNode("", true)
  ]))
}